import Vue from 'vue';
import axios from 'axios';

var axiosInstance = axios.create({
    // baseURL:  process.env.VUE_APP_BASE_API,
    timeout: 1000 * 5
});
console.log(process.env);

axiosInstance.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

/**
 * http请求响应处理函数
 */
var httpResponseHandle = function() {
    var self = this;
    console.log(self.res);
    if (self.res.code == 200) {
        self.successCallback && self.successCallback(self.res.data);
    } else {
        self.failCallback && self.failCallback(self.res.data);
    }
};

var http = {
    /**
     * 以get方式请求获取JSON数据
     * @param {Object} opts 配置项，可包含以下成员:
     * @param {String} opts.url 请求地址
     * @param {Object} opts.params 附加的请求参数
     * @param {Function} opts.successCallback 成功接收内容时的回调函数
     */
    get: function(opts) {
        return axiosInstance
            .get(opts.url, { params: opts.params })  // axios 会自动处理查询参数
            .then(function(res) {
                opts.res = res.data;
                httpResponseHandle.call(opts);  // 调用响应处理函数
                return res.data;  // 返回响应数据
            })
            .catch(function(err) {
                console.error(err);  // 错误处理
                return Promise.reject(err);  // 返回 Promise.reject 以便链式处理错误
            });
    },

    /**
     * 以get方式请求获取JSON数据
     * @param {Object} opts 配置项，可包含以下成员:
     * @param {String} opts.url 请求地址
     * @param {Object} opts.params 附加的请求参数
     * @param {Function} opts.successCallback 成功接收内容时的回调函数
     */
    post: function(opts) {
        return axiosInstance
            .post(opts.url, opts.params)  // 返回 Promise
            .then(function(res) {
                opts.res = res.data;
                httpResponseHandle.call(opts);
                return res.data;  // 返回响应数据
            })
            .catch(function(err) {
                console.error(err);  // 错误处理
                return Promise.reject(err);  // 返回 Promise.reject(err) 以便链式处理错误
            });
    },

    /**
     * 上传文件
     * @param {Object} opts 配置项，可包含以下成员:
     * @param {String} opts.url 请求地址
     * @param {Object} opts.params 上传的参数
     * @param {Function} opts.successCallback 成功接收内容时的回调函数
     */
    uploadFile: function(opts) {
        return axiosInstance
            .post(opts.url, opts.params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(function(res) {
                opts.res = res.data;
                httpResponseHandle.call(opts);
                return res.data;  
            })
            .catch(function() {});
    }
};

export default http;
